import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyAppointments } from '@/features/my-appointments'
import z from 'zod'

const myAppointmentsSearchSchema = z.object({
  startDate: z.string().optional().catch(''),
  endDate: z.string().optional().catch(''),
  status: z.array(z.string()).optional().catch([]),
  view: z.enum(['upcoming', 'calendar', 'past']).optional().catch('upcoming'),
})

export const Route = createFileRoute('/_authenticated/_organization/my-appointments/')({
  validateSearch: myAppointmentsSearchSchema,
  beforeLoad: async () => requireRoles(['client', 'primary_contact']),
  component: MyAppointments,
})

